/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './models/office.dto';
export * from './models/office-list-item.dto';
export * from './models/office-details.dto';
export * from './models/builder-office-data';

export * from './models/office-status.enum';
export * from './models/office-type.enum';
export * from './models/office-measurement.enum';
export * from './models/office-measurement-default.enum';

export * from './mappers/office.mapper';
export * from './mappers/office-list-item.mapper';
export * from './mappers/office-details.mapper';

export * from './office-rest.service';
